export default "__VITE_ASSET__BGuxbyy9__"